import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const WindowedListWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`
